export const CHANNEL_NAME = "p4m.broadcastChannel.bus";

export const Events = {
  impersonate: "impersonate",
  impersonateEnd: "impersonateEnd",
  logout: "logout"
} as const;

export type BroadcastEvent = typeof Events[keyof typeof Events];
